import React from "react";
import DOMPurify from "dompurify";
import ScrollAnimation from 'react-animate-on-scroll';
import GradientAwarding from "../../img/background_gradient_6.jpg";
import 'animate.css';

function Awarding({awardingData}) {

    //console.log(awardingData);

    return (
        <>
            {
                awardingData ?
                    <section className="mb-20">
                        <div className="container mx-auto position-relative relative mb-6 max-sm:px-4">
                            <img src={awardingData.awarding_photo} className="block w-full rounded-t-2xl sm:rounded-b-2xl"/>
                            <div
                                className="lg:absolute bottom-9 left-0 right-0 m-auto text-center text-[#e7e9ec] w-full lg:w-4/5 lg:w-3/5 px-5 sm:px-10 lg:px-20 py-12 bg-[#262563]/90 rounded-b-2xl sm:rounded-t-2xl">
                                <ScrollAnimation animateIn="animate__fadeInUp"><h2 className="sm:text-4xl text-2xl mb-4">{awardingData.awarding_title}</h2></ScrollAnimation>
                                <ScrollAnimation animateIn="animate__fadeInUp"><div dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(awardingData.awarding_text, {sanitize: true})}} /></ScrollAnimation>
                            </div>
                        </div>
                        <div className="container mx-auto max-sm:px-4">
                            <h2 className="text-center sm:text-3xl text-2xl font-bold mb-6"><ScrollAnimation animateIn="animate__fadeInUp">Рейтингування складається з трьох частин</ScrollAnimation></h2>
                            <div className="grid sm:grid-cols-3 grid-cols-1 gap-7">
                                <ScrollAnimation animateIn="animate__fadeInUp" className="p-4 rounded-xl overflow-hidden relative" style={{background: 'linear-gradient(45deg, #efefef, #c5c5ff)'}}>
                                    <div>
                                        <h3 className="mb-4">1. РЕЙТИНГ «НАЙКРАЩІ РОБОТОДАВЦІ 2025 року»</h3>
                                        <p>Загальний рейтинг роботодавців, куди увійдуть ТОП-100 найкращих компаній, які
                                            будуть обрані експертним журі з урахуванням результатів онлайн-голосування
                                            на
                                            порталі Delo.ua</p>
                                    </div>
                                </ScrollAnimation>
                                <ScrollAnimation animateIn="animate__fadeInUp" className="p-4 rounded-xl overflow-hidden relative" style={{background: 'linear-gradient(45deg, #efefef, #c5c5ff)'}}>
                                    <div>
                                        <h3 className="mb-4">2. НОМІНАЦІЇ</h3>
                                        <p>Спеціальні номінації отримають роботодавці, які за оцінками редколегії
                                            журналу
                                            «ТОП-100. Рейтинги найбільших» виявилися найкращими у окремих напрямках HR:
                                            рекрутингу, корпоративній освіті, соціальній підтримці, роботі з ветеранами
                                            та
                                            мобілізованими тощо.</p>
                                    </div>
                                </ScrollAnimation>
                                <ScrollAnimation animateIn="animate__fadeInUp" className="p-4 rounded-xl overflow-hidden relative" style={{background: 'linear-gradient(45deg, #efefef, #c5c5ff)'}}>
                                    <div className="relative z-30">
                                        <h3 className="mb-4">3. РЕЙТИНГ «НАЙКРАЩІ HRD»</h3>
                                        <p>Рейтинг найбільш авторитетних спеціалістів у сфері HR. Нагородження
                                            керівників
                                            HR-підрозділів провідних компаній, які стали творцями нових стандартів HR у
                                            своїх галузях. Переможців визначить експертне журі з урахуванням результатів
                                            онлайн-голосування на порталі Delo.ua</p>
                                    </div>
                                </ScrollAnimation>
                            </div>
                        </div>
                    </section> : ''
            }
        </>
    )
}

export default Awarding